module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-right"
  }, [_c('ul', {
    staticClass: "prd-list clearfix"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": item.to,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "alt": item.aname,
        "height": "218",
        "width": "227"
      }
    })])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2280c92c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/home-module/right-ad.vue
// module id = 1549
// module chunks = 1